var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ui-catalog-page"}},[_c('Sidebar',{staticClass:"sideBar",attrs:{"catalog-routes":_vm.catalogRoutes}}),_c('div',{staticClass:"content"},[_c('router-view'),_c('div',{staticClass:"bottomPlaceholder"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }